<template>
  <div class="newRoll">
    <span style="font-size:22px">
      <h3 style="float:left">
        <i>|</i>
      </h3>
      {{ isGaonS ? (isEnglish ? "Latest photos" : "最新滚动") : "最新滚动" }}
    </span>
    <div class="nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          v-if="label.list.length > 1"
          v-for="(item, index) in label.list"
          :index="index + ''"
          v-text="
            isGaonS
              ? isEnglish && (item.title || '').indexOf('*##*') != -1
                ? (item.title || '').split('*##*')[1]
                : (item.title || '').split('*##*')[0]
              : item.title
          "
          :key="index"
        ></el-menu-item>
      </el-menu>
      <div class="Chose" v-if="!isFlow">
        <el-checkbox v-model="showtitle">
          {{
          isGaonS
          ? isEnglish
          ? "Title and ID"
          : "图片标题和ID"
          : "图片标题和ID"
          }}
        </el-checkbox>
        <a @click="handleFlowOne" class="fone">
          <i style="color:#d4d4d4" class="iconfont icon-pubuliu" title="等高显示"></i>
        </a>
        <a @click="handleFlowTwo" class="ftwo">
          <i style="color:#333333" class="iconfont icon-xiaosuolvetu-copy" title="正常显示"></i>
        </a>
      </div>
      <div class="Chose" v-else>
        <a @click="handleFlowOne" class="fone" style="margin-left:111px">
          <i style="color:#333333" class="iconfont icon-pubuliu" title="等高显示"></i>
        </a>
        <a @click="handleFlowTwo" class="ftwo">
          <i style="color:#d4d4d4" class="iconfont icon-xiaosuolvetu-copy" title="正常显示"></i>
        </a>
      </div>
    </div>
    <div class="newRollBg" :style="curModelInfo.tpl_id == 3 ? '' : newBG">
      <div class="picShow" id="myGallery" v-if="isFlow">
        <!-- @mouseover="picMouseover(item,index)" @mouseout="picMouseout(item,index)" -->
        <a v-for="(item, index) in resource.data" @click="intoDetail(item, index)" :key="index">
          <img
            :src="item.group_index_image"
            :class="{ imgclass: item.group_id == 0 }"
            :title="
              isGaonS
                ? isEnglish && (item.group_title || '').indexOf('*##*') != -1
                  ? (item.group_title || '').split('*##*')[1]
                  : (item.group_title || '').split('*##*')[0]
                : item.group_title
            "
          />
          <div class="picShowTitle">
            <div class="picShowOne">
              <span>ID:{{ item.group_id }}</span>
              <span style="margin-right:5px;color:white">
                {{
                isArrayTime(item.created_at)
                }}
              </span>
            </div>
            <div class="picShowTwo">
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  isGaonS
                    ? isEnglish &&
                      (item.group_title || '').indexOf('*##*') != -1
                      ? (item.group_title || '').split('*##*')[1]
                      : (item.group_title || '').split('*##*')[0]
                    : item.group_title
                "
                placement="top"
              >
                <div class="picShowTitle-left">
                  {{
                  isGaonS
                  ? isEnglish &&
                  (item.group_title || "").indexOf("*##*") != -1
                  ? (item.group_title || "").split("*##*")[1]
                  : (item.group_title || "").split("*##*")[0]
                  : item.group_title
                  }}
                </div>
              </el-tooltip>
              <div class="picShowTitle-right">
                <span style="margin-right:5px;color:white;font-size:12px;">|</span>
                <span style="margin-right:5px;color:white;font-size:12px;">
                  {{
                  item.group_total
                  }}
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="picShowTwo" style="height:auto" v-else-if="!isFlow">
        <div class="picFlow">
          <div
            class="picFlowItem"
            :class="{ picA: showtitle, picB: !showtitle }"
            v-for="(item, index) in resource.data"
            @click="intoDetail(item, index)"
            :key="index"
          >
            <img :src="item.group_index_image" :class="{ imgclass: item.group_id == 0 }" />
            <div class="newrollgroupinfo" v-if="showtitle">
              <div class="newrollgroupinfo-reg">
                {{ item.created_at ? item.created_at || "" : item.created_at }}
                <span
                  style="float:right;font-size:12px;color:#515A6E"
                >
                  {{
                  item.group_total ? `${item.group_total}张` : ""
                  }}
                </span>
              </div>
              <div
                class="newrollgroupinfo-reg-title"
                :title="
                  isGaonS
                    ? isEnglish &&
                      (item.group_title || '').indexOf('*##*') != -1
                      ? (item.group_title || '').split('*##*')[1]
                      : (item.group_title || '').split('*##*')[0]
                    : item.group_title
                "
              >
                {{
                isGaonS
                ? isEnglish &&
                (item.group_title || "").indexOf("*##*") != -1
                ? (item.group_title || "").split("*##*")[1]
                : (item.group_title || "").split("*##*")[0]
                : item.group_title
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align:center; margin:30px 0" v-if="resource.data.length > 0">
        <el-button
          style="width:266px;height:50px;border-radius:4px;"
          @click="toSearchCategory"
          id="searchButton"
        >查看更多</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Waterfall from "@/components/Waterfall";
import { getResource, getResourceToken } from "@/services/api.js";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      //布局
      isFlow: true,
      //mainbottom
      newBG: { background: "#fff" },
      activeIndex: "0",
      currentPage: 1,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      resource: { data: [{ extension_info: { oss_400: "" } }] },
      currentType: "",
      showtitle: true,
      category_id: 0
    };
  },
  props: {
    label: {
      type: Object,
      default() {
        return {
          id: "",
          list: []
        };
      }
    }
  },
  watch: {},
  computed: {
    ...mapGetters([
      "webModels",
      "modelsInfo",
      "curModelInfo",
      "webID",
      "showSite",
      "isGaonS",
      "isEnglish"
    ])
  },

  mounted() {
    var id = setInterval(() => {
      if (this.label.list[0] && this.label.list[0].title !== "") {
        clearInterval(id);
        this.handleSelect(0);
      }
    }, 0);
  },
  created() {
    let val = localStorage.getItem("newroll_isflow");
    this.isFlow = eval(val);
  },
  methods: {
    isArrayTime(data) {
      if (/\d{4}-\d{1,2}-\d{1,2}/g.exec(data)) {
        return /\d{4}-\d{1,2}-\d{1,2}/g.exec(data).join("");
      } else {
        return /\d{4}-\d{1,2}-\d{1,2}/g.exec(data);
      }
    },
    picMouseover(item, index) {
      if (item.group_id == 0) {
        return;
      }
      item.isShowTitle = true;
      this.$set(this.resource.data, index, item);
    },
    picMouseout(item, index) {
      item.isShowTitle = false;
      this.$set(this.resource.data, index, item);
    },

    //滚动布局
    handleFlowOne() {
      localStorage.setItem("newroll_isflow", true);
      this.isFlow = true;
    },
    handleFlowTwo() {
      localStorage.setItem("newroll_isflow", false);
      this.isFlow = false;
    },
    handleSelect(key, keyPath) {
      const category_id = this.label.list[key].category_id;
      this.currentType = this.label.list[key].category_id + "";
      this.currentPage = 1;
      var data = {
        category: this.currentType == "1" ? "" : this.currentType,
        search_type: 2 + "",
        customer_id: this.webID,
        paginate: 45
      };
      if (window.location.host.indexOf("zjkda") > -1) {
        data.paginate = 15;
      }
      data.sort_by_number = "desc";

      // 判断是否为子站点
      var ifChildSite = this.showSite;
      // debugger;
      if (ifChildSite) {
        // 是子站点
        var loginToken = sessionStorage.getItem("token");
        //使用已登录的搜索接口
        let option = {
          headers: { Authorization: "Bearer " + loginToken }
        };
        data.search_type = 2;
        getResourceToken(data, null, option).then(res => {
          if (res.status_code == 1) {
            res.data.data.forEach(item => {
              item.isShowTitle = false;
            });
            this.resource = res.data;

            this.category_id = category_id;
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        });
      } else {
        getResource(data, 2).then(res => {
          if (res.status_code == 1) {
            res.data.data.forEach(item => {
              item.isShowTitle = false;
            });
            this.resource = res.data;

            this.category_id = category_id;
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        });
      }
    },
    toSearchCategory() {
      document.getElementById("searchButton").blur();

      let routeData = this.$router.resolve({
        path: "/search",
        query: {
          type: 0,
          text: "",
          isEnglish: this.isEnglish,
          category_id: this.category_id === "1" ? "" : this.category_id,
          type: 2
        }
      });
      window.open(routeData.href, "_blank");
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      var data = {
        review_state: 1 + "",
        category_view: this.currentType == "1" ? "" : this.currentType,
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webID,
        paginate: 45
      };
      if (window.location.host.indexOf("zjkda") > -1) {
        data.paginate = 15;
      }
      getResource(data, null, val).then(res => {
        if (res.status_code == 1) {
          res.data.data.forEach(item => {
            item.isShowTitle = false;
          });
          this.resource = res.data;
        }
      });
    },
    intoDetail(item, index) {
      if (item.group_id == 0) {
        let routeData = this.$router.resolve({
          path: "/search",
          query: {
            type: 0,
            text: "",
            isEnglish: this.isEnglish,
            category_id: item.category_id === "1" ? "" : item.category_id,
            type: 2
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        // 单张路由页
        let routeData = this.$router.resolve({
          path: "/searchSingle",
          query: {
            isEnglish: false,
            type: 1,
            text: "",
            group_id: item.group_id
          }
        });

        window.open(routeData.href, "_blank");
      }
    }
  },
  components: {
    Waterfall
  }
};
</script>
<style lang="less">
.newRoll {
  .el-button:hover {
    background: linear-gradient(
      270deg,
      rgba(170, 0, 1, 0.98) 0%,
      rgba(233, 69, 10, 1) 100%
    );
    color: #fff;
    border-radius: 4px;
  }
  .el-button:focus {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
}
</style>
<style lang="less" scoped>
.picA {
  margin: 14px 4px 65px 4px;
}
.picB {
  margin: 4px 4px 4px 4px;
}
.newrollgroupinfo {
  height: 70px;
  line-height: 70px;

  .newrollgroupinfo-reg {
    height: 30px;
    line-height: 30px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .newrollgroupinfo-reg-title {
    font-size: 14px;
    height: 40px;
    line-height: 20px;
    text-align: left;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.imgclass {
  width: 128px !important;
  height: 128px !important;
}
.newRoll {
  width: 100%;
  height: 100%;
  span {
    margin: 0 auto;
    // width: 1200px;
    font-size: 24px;
    color: #333333;
    i {
      color: #f84949;
      margin-right: 8px;
    }
  }
  .nav {
    position: relative;
    // width: 1200px;
    margin: 0 auto;
    .el-menu-demo {
      border-bottom: none;
      height: 40px;
      .is-active.el-menu-item {
        color: #f05941;
      }
      .el-menu-item {
        cursor: pointer;
        margin-top: 18px;
        border-bottom-color: #f05941;
        margin-right: 20px;
        padding: 0;
        height: 26px;
        font-size: 14px;
        line-height: 26px;
        color: #000;
      }
    }
  }
  .Chose {
    position: absolute;
    right: 0;
    top: 0;
    width: 180px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .fone {
      margin-left: 10px;
    }
    .flowLeft {
      background: url("../../static/images/icon/flowTwo.png") no-repeat;
      background-size: cover;
    }
    .flowRight {
      background: url("../../static/images/icon/deuceTwo.png") no-repeat;
      background-size: cover;
    }
    i {
      float: right;
      margin-right: 16px;
      width: 25px;
      // height: 25px;
      line-height: 60px;
    }
  }
  .Chose {
    a:hover {
      color: #f05941;
    }
  }
  .newRollBg {
    margin-top: 18px;
    width: 100%;
    // background: #e7e7e7;
  }
  .picShow {
    // width: 1200px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    // padding-top: 20px;
    margin: 0 auto;
    &::after {
      content: "";
      flex-grow: 999999;
    }
    a:hover {
      .picShowTitle {
        height: 60px;
      }
    }
    a {
      margin: 5px;
      cursor: pointer;
      flex-grow: 1;
      line-height: 0;
      position: relative;
      .picShowOne {
        height: 30px;
        line-height: 30px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          font-size: 12px;
          color: #fff;
          margin-left: 12px;
        }
      }
      .picShowTwo {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
      }
      .picShowTitle {
        color: white;
        height: 0px;
        transition: all 0.3s;
        position: absolute;
        overflow: hidden;
        bottom: 0px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        line-height: 40px;
        .picShowTitle-left {
          margin-left: 10px;
          width: calc(~"100% - 40px");
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      img {
        height: 220px;
        // min-width: 100%;
        min-width: 100%;
        object-fit: cover;
      }
    }
  }
  .picShowTwo {
    // width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    flex-wrap: wrap;
    .picFlow {
      cursor: pointer;
      margin-top: 15px;
      flex-grow: 1;
      display: flex;
      display: -webkit-flex;
      flex-wrap: wrap;
      .picFlowItem {
        display: inline-block;
        position: relative;
        width: 232px;
        height: 236px;
        border: 1px solid #ededed;
        box-sizing: border-box;
        text-align: center;
        line-height: 232px;
        // margin-right: 35px;
        // .picFlowAItem {
        //   height: 180px;
        img {
          vertical-align: middle;
          max-height: 98%;
          max-width: 100%;
          object-fit: cover;
        }
        // }
      }
    }
  }
  .pagination {
    // width: 1200px;
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newRoll.vue